import React from "react";
import { Link } from "react-router-dom";
import { Image, Button } from "react-bootstrap";
import Svg404 from "./../../Assets/Svg/404.svg";
import "./NotFound.page.scss";

class NotFoundPage extends React.Component {
  render() {
    return (
      <div className="row mt-4 mb-4 d-flex align-items-center">
        <div className="col-12 col-sm-6">
          <Image src={Svg404} fluid />
        </div>
        <div className="col-12 col-sm-6">
          <div className="row text-center mb-4">
            <div className="col-12">
              <h1 className="text-primary">Opss pagína no encontrada!</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-lg-3 offset-lg-9">
              <Link to="/">
                <Button type="button" variant="outline-secondary" block>
                  Volver
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NotFoundPage;
